import { addClass } from './add'
import { hasClass } from './has'
import { removeClass } from './remove'
import { toggleClass } from './toggle'

export const classList = {
  add: addClass,
  has: hasClass,
  remove: removeClass,
  toggle: toggleClass
}
